// components/Projects.jsx
import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import { FaGithub, FaArrowUpRightFromSquare } from "react-icons/fa6";
import { background } from "../../theme/colors";

const projects = [
  {
    title: "SendZip",
    description: "A simple and secure service to share .zip files online.",
    image: "./images/SendZip.png",
    github: "https://github.com/pratik7262/SendZip-Backend",
    liveLink: "https://sendzip.pratikshinde.com/",
  },
  {
    title: "TypeCast",
    description:
      "A real-time collaborative text editor for seamless team writing.",
    image: "./images/typeCast.png",
    github: "https://github.com/pratik7262/typeCast-backend",
    liveLink: "https://dev-swart-phi.vercel.app/typeCast",
  },
  // {
  //   title: "Project Three",
  //   description: "A short description of project three.",
  //   image: "./images/project3.png",
  //   github: "https://github.com/",
  //   liveLink: "https://example.com",
  // },
];

export default function Projects() {
  return (
    <Box id="projects" sx={{ py: 8, backgroundColor: background }}>
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 700,
          mb: 6,
          fontFamily: "Poppins, sans-serif",
        }}
      >
        Projects
      </Typography>

      {/* Projects Grid */}
      <Grid container spacing={4} justifyContent="center">
        {projects.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                // maxWidth: 300,
                boxShadow: 3,
                borderRadius: 3,
                overflow: "hidden",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: 6,
                },
                // When card hovered, show overlay only (overlay sits inside image container)
                "&:hover .overlay": {
                  transform: "translateY(0%)",
                },
              }}
            >
              {/* Image container (overlay applies only here) */}
              <Box sx={{ position: "relative", overflow: "hidden" }}>
                <CardMedia
                  component="img"
                  image={project.image}
                  alt={project.title}
                  sx={{ height: 200, objectFit: "cover" }}
                />

                {/* Hover Overlay (desktop only) - visible only over image */}
                <Box
                  className="overlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.6)",
                    display: { xs: "none", md: "flex" },
                    justifyContent: "center",
                    alignItems: "center",
                    transform: "translateY(100%)",
                    transition: "transform 0.35s cubic-bezier(.2,.8,.2,1)",
                    zIndex: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    href={project.liveLink}
                    target="_blank"
                    sx={{
                      borderRadius: 50,
                      minWidth: "50px",
                      height: "50px",
                      padding: 0,
                      fontSize: "1.2rem",
                    }}
                    aria-label={`Open ${project.title} live`}
                  >
                    <FaArrowUpRightFromSquare />
                  </Button>
                </Box>
              </Box>

              {/* Card Content */}
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {project.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1, wordBreak: "break-word" }}
                >
                  {project.description}
                </Typography>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    mt: 2,
                  }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<FaGithub />}
                    href={project.github}
                    target="_blank"
                    aria-label={`View ${project.title} code on GitHub`}
                  >
                    View Code
                  </Button>

                  {/* Live Link Button for touch devices (always visible on small screens) */}
                  <Button
                    variant="contained"
                    color="primary"
                    href={project.liveLink}
                    target="_blank"
                    sx={{
                      display: { xs: "flex", md: "none" },
                      borderRadius: 50,
                      minWidth: "50px",
                      height: "50px",
                      padding: 0,
                      fontSize: "1.2rem",
                    }}
                    aria-label={`Open ${project.title} live`}
                  >
                    <FaArrowUpRightFromSquare />
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* MORE PROJECTS - placed OUTSIDE grid so it always sits below the project rows */}
      {/* <Box sx={{ textAlign: "center", mt: 6 }}>
        <Button
          variant="text"
          color="primary"
          href="https://pratikshinde.in/projects"
          target="_blank"
          sx={{
            fontWeight: 600,
            fontSize: "1.05rem",
            textTransform: "none",
          }}
          aria-label="See more projects"
        >
          More Projects →
        </Button>
      </Box> */}
    </Box>
  );
}
